(function () {
  'use strict';
  
  /**
   * @ngdoc service
   * @name vcdms.doctype.factory:Doctype
   *
   * @description
   *
   */
  angular
    .module('vcdms.vcdoctype')
    .factory('Doctype', Doctype);
  
  
  Doctype.$inject = ['restmod'];
  function Doctype(restmod) {
    return restmod.model('/routes/doctypes').mix({
      created: {
        init: function () {
          return moment().toISOString();
        }
      },
      active: {init: true},
      $extend: {
        Model: {
          $searchahead: function (_params) {
            return this.$collection().$decorate({
              'before-request': function (_req) {
                _req.method = 'GET';
                _req.url = '/routes/doctypes/searchahead';
              }
            }, function () {
              return this.$fetch(_params);
            });
          },
          $searchBy: function (key, val) {
            let query = {};
            query[key] = val;
            return this.$search(query);
          }
        } // Model
      }// extend
    });
  }
  
// klammerfriedhof
}());
